import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import ornament from './pictures/ornament.png';

const Ornament = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC x GEN1 Ornament Night</h2>
                    <p class="site-post-meta">December 4th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    <br></br>
                    <br></br>
                    To celebrate the most wonderful time of the year, WiC collaborated with GEN1 to host  “Ornament Night!” Attendees created their own custom ornament for decoration while enjoying some warm hot chocolate and sweet sugar cookies! ❄️☃️
                    </p>
                    <img src={ornament} alt="pic6"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Ornament;
